import React, { Component } from 'react'
import { connect } from 'react-redux'

class QuestionsStats extends Component {
  render () {
    const { comments } = this.props
    const questions = comments.questions.length
    const answered = comments.answered.length
    let likes = []

    comments.questions.forEach(q => {
      q.likes && q.likes.forEach(l => {
        likes.findIndex(like => like.participant === l.participant) === -1 &&
          (likes.push(l))
      })
    })

    comments.answered.forEach(q => {
      q.likes && q.likes.forEach(l => {
        likes.findIndex(like => like.participant === l.participant) === -1 &&
          (likes.push(l))
      })
    })

    return [
      <div className='dashboard-teams-row' key='1'>
        <div className='cell-subject'>-----------------------</div>
      </div>,
      <div className='dashboard-teams-row' key='2'>
        <div className='cell-subject'>Questions</div>
        <div className='cell-tags cell-looking-for'>
          {questions + answered}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='3'>
        <div className='cell-subject unset-text-transform'>Asked</div>
        <div className='cell-tags cell-looking-for'>
          {questions}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='4'>
        <div className='cell-subject unset-text-transform'>Answered</div>
        <div className='cell-tags cell-looking-for'>
          {answered}
        </div>
      </div>,
      <div className='dashboard-teams-row' key='5'>
        <div className='cell-subject unset-text-transform'>People enjoyed questions</div>
        <div className='cell-tags cell-looking-for'>
          {likes.length}
        </div>
      </div>
    ]
  }
}

const mapStateToProps = (state) => {
  return {
    comments: state.comments
  }
}

export default connect(mapStateToProps)(QuestionsStats)



// WEBPACK FOOTER //
// ./src/screens/administration/statistics/QuestionsStats.js